// extracted by mini-css-extract-plugin
export default {"container":"socials_container__R0lET"};